import registry from './pages.json';
import type { PageDefinition, PageRegistry } from './types';

export const PAGES = registry as unknown as PageRegistry;

export const pageById = new Map<string, PageDefinition>(
  PAGES.pages.map((page) => [page.id, page]),
);

/** Converts a design route pattern into a React Router path. */
export function toRouterPath(route: string): string {
  return route;
}

export function pagesByArea(area: PageDefinition['area']): PageDefinition[] {
  return PAGES.pages.filter((page) => page.area === area);
}

/** Admin navigation, grouped exactly as the design registry orders it. */
export function adminNavGroups(): { name: string; pages: PageDefinition[] }[] {
  const groups: { name: string; pages: PageDefinition[] }[] = [];
  for (const page of pagesByArea('admin')) {
    // Auth screens live outside the shell.
    if (['A001', 'A002', 'A003', 'A004'].includes(page.id)) continue;
    let group = groups.find((entry) => entry.name === page.group);
    if (!group) {
      group = { name: page.group, pages: [] };
      groups.push(group);
    }
    group.pages.push(page);
  }
  return groups;
}

/** Game-scope menu: the same screens, viewed through one game's data. */
export function gameScopeGroups(): { name: string; pages: PageDefinition[] }[] {
  return PAGES.game_scope_menu.map((group) => ({
    name: group.name,
    pages: group.items
      .map(([id]) => pageById.get(id))
      .filter((page): page is PageDefinition => Boolean(page)),
  }));
}

export function statesFor(type: string): string[] {
  return PAGES.states_by_type[type] ?? ['READY', 'LOADING', 'EMPTY'];
}
